import { ArrowUpRight } from "lucide-react";
import { PADS, BUY_URL } from "@/data/products";
import { Reveal } from "@/components/Reveal";

const PadCard = ({ pad }) => {
  const isGold = pad.accent === "gold";
  return (
    <a
      href={BUY_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`pad-card-${pad.id}`}
      className={`group relative block h-full w-full border border-white/10 bg-ebc-surface overflow-hidden transition-colors duration-500 ${
        isGold ? "hover:border-ebc-gold" : "hover:border-ebc-red"
      } ${pad.feature ? "min-h-[380px] sm:min-h-[460px]" : "min-h-[300px] sm:min-h-[340px]"}`}
    >
      <div className="absolute inset-0 overflow-hidden">
        <img
          src={pad.image}
          alt={pad.name}
          loading="lazy"
          className="h-full w-full object-cover opacity-45 grayscale-[0.3] transition-all duration-[900ms] ease-out group-hover:scale-105 group-hover:opacity-70 group-hover:grayscale-0"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/20" />
        <div
          className={`absolute -inset-1 opacity-0 group-hover:opacity-100 transition-opacity duration-500 ${
            isGold
              ? "bg-[radial-gradient(circle_at_50%_120%,rgba(212,175,55,0.25),transparent_60%)]"
              : "bg-[radial-gradient(circle_at_50%_120%,rgba(230,35,20,0.28),transparent_60%)]"
          }`}
        />
      </div>

      <div className="relative z-10 h-full flex flex-col justify-between p-6 sm:p-8">
        <div className="flex items-start justify-between">
          <span className={`font-mono text-xs tracking-[0.2em] ${isGold ? "text-ebc-gold" : "text-ebc-red"}`}>
            [{pad.num}]
          </span>
          <span className="opacity-0 group-hover:opacity-100 translate-x-2 group-hover:translate-x-0 transition-all duration-300">
            <ArrowUpRight className={`w-6 h-6 ${isGold ? "text-ebc-gold" : "text-ebc-red"}`} />
          </span>
        </div>

        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-400 mb-2">
            {pad.tag}
          </p>
          <h3
            className={`font-display uppercase leading-none tracking-tight text-white ${
              pad.feature ? "text-5xl sm:text-7xl" : "text-4xl sm:text-5xl"
            }`}
          >
            {pad.name}
          </h3>
          <p
            className={`mt-3 text-neutral-400 leading-relaxed ${
              pad.feature ? "text-sm sm:text-base max-w-lg" : "text-sm max-w-xs"
            }`}
          >
            {pad.desc}
          </p>
        </div>
      </div>
    </a>
  );
};

export const PadsSection = () => {
  return (
    <section id="pads" data-testid="pads-section" className="relative bg-black py-20 sm:py-28">
      <div className="mx-auto max-w-[1600px] px-5 sm:px-8">
        <Reveal className="mb-10 sm:mb-14 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-ebc-red mb-4">
              / 01 — Brake Pads
            </p>
            <h2 className="font-display uppercase leading-[0.85] tracking-tight text-white text-5xl sm:text-7xl lg:text-8xl">
              Grip. On
              <br />
              <span className="text-stroke">Demand.</span>
            </h2>
          </div>
          <p className="max-w-sm text-sm sm:text-base text-neutral-400 leading-relaxed">
            Five friction formulas engineered for every rider — from progressive street
            feel to zero-fade race bite.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-3 sm:gap-4">
          {PADS.map((pad, i) => (
            <Reveal key={pad.id} delay={i * 0.06} className={pad.span}>
              <PadCard pad={pad} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
